import React from 'react'

function Footer() {
    return (
        <footer className="page-footer">
            <p className="mb-0">
                <span>اداره‌ کل فناوری و سامانه‌های نوین</span>
                <span> &#169; {new Date().toLocaleDateString('fa-IR', {year: 'numeric'})}</span>
            </p>
        </footer>
    )
}

export default Footer;